import axios from "axios";
import { API, getAuthHeader } from "../constants/api.const"; // Adjust the path based on your project structure
import { toast } from "react-toastify";
import { API_URI } from "../environment";

export const handleStartRecording = async (payload) => {
  try {
    const res = await axios.post(
      API.START_RECORDING,
      { ...payload },
      {
        headers: getAuthHeader(),
      }
    );
    return res;
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Error happened while started recording"
    );
    console.error("Error happened while started recording");
  }
};

export const submitRecording = async (data) => {
  const backendFD = new FormData();
  backendFD.append("recording_file", data.recording_file);
  backendFD.append("recording_id", data.recording_id);
  backendFD.append("recording_duration", data.recording_duration);
  try {
    const res = await axios.post(API.SUBMIT_RECORDING, backendFD, {
      headers: getAuthHeader(),
    });
    return res;
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Error happened while submit recording"
    );
    console.error("Error happened while submit recording");
  }
};

export const summaryView = async (data) => {
  try {
    const res = await axios.post(
      API.SUMMARY_VIEW,
      { ...data },
      {
        headers: getAuthHeader(),
      }
    );

    return res;
  } catch (error) {
    console.log("error", error);
    toast.error(
      error?.response?.data?.message || "Error happened while summary view"
    );
    console.error("Error happened while summary view");
  }
};

export const getDiagnoszas = async () => {
  try {
    const res = await axios.get(API.GET_DIAGNOSZAS, {
      headers: getAuthHeader(),
    });
    return res.data.data;
  } catch (error) {
    toast.error("Error happened while fetching Diagnoszas");
    console.error("Error happened while fetching Diagnoszas");
  }
};

export const getSifreStoritve = async () => {
  const res = await axios.get(API.GET_SIFRE_STORITVE, {
    headers: getAuthHeader(),
  });
  return res.data.data;
};

export const addNewSifreCode = async (data) => {
  try {
    await axios.post(
      API.ADD_NEW_SIFRE_CODE,
      { ...data },
      {
        headers: getAuthHeader(),
      }
    );
    toast.success("Add new sifre code successfully");
  } catch (error) {
    toast.error("Error happened while Add new sifre code");
    console.error("Error happened while Add new sifre code");
  }
};

export const addDiagnoszaCode = async (data) => {
  try {
    await axios.post(
      API.ADD_DIAGNOSZA_CODE,
      { ...data },
      {
        headers: getAuthHeader(),
      }
    );
    toast.success("Add Diagnosza code successfully");
  } catch (error) {
    toast.error("Error happened while Add Diagnosza code");
    console.error("Error happened while Add Diagnosza code");
  }
};

export const getRecordingStatus = async (recording_id) => {
  const backendFD = new FormData();
  backendFD.append("recording_id", recording_id);
  try {
    const res = await axios.post(API.RECORDING_STATUS, backendFD, {
      headers: getAuthHeader(),
    });
    return res;
  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
        "Error happened while get recording status"
    );
    console.error("Error happened while get recording status");
  }
};

export const editRecordingSummary = async (data) => {
  try {
    return await axios.patch(
      API.EDIT_RECORDING_SUMMARY,
      { ...data },
      {
        headers: getAuthHeader(),
      }
    );
  } catch (error) {
    toast.error("Napaka pri dodajanju kode diagnoze");
    console.error("Error happened while Add Diagnosza code");
  }
};

export const fetchConsultationSummaries = async ({ pageParam }) => {
  // const API_URI = "http://156.67.82.131:8006";
  let url = pageParam || "/api/consulations/summaries/?page=1";
  if (url.startsWith(API_URI)) {
    url = url.replace(API_URI, "");
  }
  const fullUrl = `${API_URI}${url}`;
  const { data } = await axios.get(fullUrl, {
    headers: getAuthHeader(),
  });
  return data.data;
};

export const deleteSummary = async (summaryId) => {
  const formData = new FormData();
  formData.append("summary_id", summaryId);
  await axios.delete(API_URI + "/api/consulations/delete-summary/", {
    headers: getAuthHeader(),
    data: formData,
  });
};

export const updateReviewStatus = async ({ recordingId, isReviewed }) => {
  const response = await axios.patch(
    API_URI + "/api/consulations/review-summary/",
    { recording_id: recordingId, is_reviewed: isReviewed },
    { headers: getAuthHeader() }
  );
  return response.data;
};
